import { withPosthog } from '~~/services/analytics';

interface Variant {
    variant: string;
    title: string;
    subtitle?: string;
}

export function useGetVariant(featureFlagName: string, variants: Array<Variant>, control: Variant) {
    // TODO: This composable was built only for heros originally, refactor to work for different use cases
    const heroTitle = ref(control.title);
    const heroSubtitle = ref(control.subtitle);

    // PostHog loads after the page is interactive, so the control renders first (and is what is
    // prerendered). Once PostHog is ready, apply the visitor's variant: onFeatureFlags fires at once
    // when flags are cached from an earlier visit, else when they arrive. getFeatureFlag also records
    // the $feature_flag_called exposure.
    let unsubscribe: (() => void) | undefined;
    let disposed = false;
    onScopeDispose(() => {
        disposed = true;
        unsubscribe?.();
    });
    withPosthog((posthog) => {
        if (disposed) return;
        unsubscribe = posthog.onFeatureFlags(() => {
            const featureFlag = posthog.getFeatureFlag(featureFlagName);
            const variant = variants.find((v) => v.variant === featureFlag);
            if (variant) {
                heroTitle.value = variant.title;
                heroSubtitle.value = variant.subtitle;
            }
        });
    });

    return {
        heroTitle,
        heroSubtitle,
    };
}
